import { render, staticRenderFns } from "./KeywordGrid.vue?vue&type=template&id=0fd0d91f&scoped=true&"
import script from "./KeywordGrid.vue?vue&type=script&lang=js&"
export * from "./KeywordGrid.vue?vue&type=script&lang=js&"
import style0 from "./KeywordGrid.vue?vue&type=style&index=0&id=0fd0d91f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0d91f",
  null
  
)

/* custom blocks */
import block0 from "@/javascripts/grid.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fapp%2Fjavascript%2Fpages%2FSummary%2FTopMovements%2FKeywordGrid.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./KeywordGrid.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports